<template>
  <base-dialog :showDialog="showDialog" :width="750">
    <template v-slot:body>
      <v-card dark>
        <v-card-title>
          <span>Dados do Orçamento [ {{ orderData.displayId }} ]</span>
        </v-card-title>
        <v-card-text>
          <v-tabs v-model="selectedTab">
            <v-tabs-slider color="red"></v-tabs-slider>
            <v-tab v-if="orderData.id != null">
              Geral
            </v-tab>

            <v-tab-item v-if="orderData.id != null">
              <v-card dark tile>
                <v-card-text>
                  <div class="d-flex flex-wrap">
                    <v-text-field
                      dark
                      disabled
                      outlined
                      dense
                      label="Data"
                      class="mx-1 text-caption"
                      v-model="orderData.createdAt"
                    />
                    <v-text-field
                      dark
                      disabled
                      outlined
                      dense
                      label="Id do pedido"
                      class="mx-1 text-caption"
                      v-model="orderData.id"
                    />
                    <v-text-field
                      dark
                      disabled
                      outlined
                      dense
                      label="Número do pedido"
                      class="mx-1 text-caption"
                      v-model="orderData.displayId"
                    />
                    <v-text-field
                      dark
                      disabled
                      outlined
                      dense
                      label="Início da produção"
                      class="mx-1 text-caption"
                      v-model="orderData.preparationStartDateTime"
                    />
                    <v-text-field
                      dark
                      disabled
                      outlined
                      dense
                      label="Forma da Entrega"
                      class="mx-1 text-caption"
                      v-model="orderData.orderTiming"
                    />
                    <v-text-field
                      dark
                      disabled
                      outlined
                      dense
                      label="Tipo do Orçamento"
                      class="mx-1 text-caption"
                      v-model="orderData.orderType"
                    />

                    <c-input-money
                      class="mx-1 text-caption"
                      v-model="orderData.total.deliveryFee"
                      label="Taxa de Entrega"
                      dark
                      dense
                      outlined
                      reverse
                      disabled
                      v-bind:valueWhenIsEmpty="'0'"
                      v-bind:options="{
                        locale: 'pt-BR',
                        prefix: '',
                        suffix: `${getCurrencies[0].cifrao}`,
                        length: 11,
                        precision: `${getQntDecimais(getCurrencies[0])}`,
                      }"
                    />
                    <c-input-money
                      class="mx-1 text-caption"
                      v-model="orderData.total.benefits"
                      label="Descontos"
                      dark
                      dense
                      outlined
                      reverse
                      disabled
                      v-bind:valueWhenIsEmpty="'0'"
                      v-bind:options="{
                        locale: 'pt-BR',
                        prefix: '',
                        suffix: `${getCurrencies[0].cifrao}`,
                        length: 11,
                        precision: `${getQntDecimais(getCurrencies[0])}`,
                      }"
                    />
                    <c-input-money
                      class="mx-1 text-caption"
                      v-model="orderData.total.subTotal"
                      label="Subtotal"
                      dark
                      dense
                      outlined
                      reverse
                      disabled
                      v-bind:valueWhenIsEmpty="'0'"
                      v-bind:options="{
                        locale: 'pt-BR',
                        prefix: '',
                        suffix: `${getCurrencies[0].cifrao}`,
                        length: 11,
                        precision: `${getQntDecimais(getCurrencies[0])}`,
                      }"
                    />
                    <c-input-money
                      class="mx-1 text-caption"
                      v-model="orderData.total.orderAmount"
                      label="Valor Total"
                      dark
                      dense
                      outlined
                      reverse
                      disabled
                      v-bind:valueWhenIsEmpty="'0'"
                      v-bind:options="{
                        locale: 'pt-BR',
                        prefix: '',
                        suffix: `${getCurrencies[0].cifrao}`,
                        length: 11,
                        precision: `${getQntDecimais(getCurrencies[0])}`,
                      }"
                    />
                    <v-text-field
                      dark
                      disabled
                      outlined
                      dense
                      label="Canal de venda"
                      class="mx-1 text-caption"
                      v-model="orderData.salesChannel"
                    />
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab v-if="orderData.payments">Cliente</v-tab>
            <v-tab-item v-if="orderData.customer != null">
              <v-card dark tile>
                <v-card-text>
                  <div class="d-flex flex-wrap">
                    <v-text-field
                      dark
                      disabled
                      outlined
                      dense
                      label="Nome"
                      class="mx-1 text-caption"
                      v-model="orderData.customer.name"
                    />
                    <v-text-field
                      dark
                      disabled
                      outlined
                      dense
                      label="CPF"
                      class="mx-1 text-caption"
                      v-model="orderData.customer.documentNumber"
                    />
                  </div>
                  <div class="d-flex flex-wrap">
                    <v-text-field
                      dark
                      disabled
                      outlined
                      dense
                      label="Qtde Orçamentos"
                      class="mx-1 text-caption"
                      v-model="orderData.customer.ordersCountOnMerchant"
                    />
                    <v-text-field
                      dark
                      disabled
                      outlined
                      dense
                      label="Telefone"
                      class="mx-1 text-caption"
                      v-model="orderData.customer.phone.number"
                    />
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab v-if="orderData.delivery">
              Delivery
            </v-tab>
            <v-tab-item v-if="orderData.delivery != null">
              <v-card dark tile>
                <v-card-text>
                  <div class="d-flex flex-wrap">
                    <v-text-field
                      dark
                      outlined
                      disabled
                      dense
                      class="text-caption mx-1"
                      label="Endereço"
                      v-model="orderData.delivery.deliveryAddress.streetName"
                    />
                    <v-text-field
                      dark
                      outlined
                      disabled
                      dense
                      class="text-caption mx-1"
                      label="Número"
                      v-model="orderData.delivery.deliveryAddress.streetNumber"
                    />
                  </div>
                  <div class="d-flex flex-wrap">
                    <v-text-field
                      dark
                      outlined
                      disabled
                      dense
                      class="text-caption mx-1"
                      label="Complemento"
                      v-model="orderData.delivery.deliveryAddress.complement"
                    />
                    <v-text-field
                      dark
                      outlined
                      disabled
                      dense
                      class="text-caption mx-1"
                      label="CEP"
                      v-model="orderData.delivery.deliveryAddress.postalCode"
                    />
                    <v-text-field
                      dark
                      outlined
                      disabled
                      dense
                      class="text-caption mx-1"
                      label="Bairro"
                      v-model="orderData.delivery.deliveryAddress.neighborhood"
                    />
                    <v-text-field
                      dark
                      outlined
                      disabled
                      dense
                      class="text-caption mx-1"
                      label="Cidade"
                      v-model="orderData.delivery.deliveryAddress.city"
                    />
                    <v-text-field
                      dark
                      outlined
                      disabled
                      dense
                      class="text-caption mx-1"
                      label="Estado"
                      v-model="orderData.delivery.deliveryAddress.state"
                    />
                    <v-text-field
                      dark
                      outlined
                      disabled
                      dense
                      class="text-caption mx-1"
                      label="País"
                      v-model="orderData.delivery.deliveryAddress.country"
                    />
                    <v-text-field
                      dark
                      outlined
                      disabled
                      dense
                      class="text-caption mx-1"
                      label="Entregue por"
                      v-model="orderData.delivery.deliveredBy"
                    />
                    <v-text-field
                      dark
                      outlined
                      disabled
                      dense
                      class="text-caption mx-1"
                      label="Observações"
                      v-model="orderData.delivery.deliveryAddress.observations"
                    />
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab v-if="orderData.payments">Pagamento</v-tab>
            <v-tab-item v-if="orderData.payments != null">
              <v-card dark tile>
                <v-card-text>
                  <div class="d-flex flex-wrap">
                    <c-input-money
                      class="mx-1 text-caption"
                      v-model="orderData.payments.prepaid"
                      label="Valor pago"
                      dark
                      dense
                      outlined
                      reverse
                      disabled
                      v-bind:valueWhenIsEmpty="'0'"
                      v-bind:options="{
                        locale: 'pt-BR',
                        prefix: '',
                        suffix: `${getCurrencies[0].cifrao}`,
                        length: 11,
                        precision: `${getQntDecimais(getCurrencies[0])}`,
                      }"
                    />
                    <c-input-money
                      class="mx-1 text-caption"
                      v-model="orderData.payments.pending"
                      label="Pendente"
                      dark
                      dense
                      outlined
                      reverse
                      disabled
                      v-bind:valueWhenIsEmpty="'0'"
                      v-bind:options="{
                        locale: 'pt-BR',
                        prefix: '',
                        suffix: `${getCurrencies[0].cifrao}`,
                        length: 11,
                        precision: `${getQntDecimais(getCurrencies[0])}`,
                      }"
                    />
                  </div>
                  <v-data-table
                    :headers="headersMethods"
                    :items="orderData.payments.methods"
                    item-key="method"
                    dense
                  >
                    <template v-slot:item.value="{ item }">
                      <v-chip dark small>
                        {{ formatCurrency(0, item.value) }}
                      </v-chip>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab v-if="orderData.items">Itens</v-tab>
            <v-tab-item v-if="orderData.items.length > 0">
              <v-card dark tile>
                <v-card-text>
                  <v-data-table
                    :headers="headersItems"
                    :items="orderData.items"
                    item-key="id"
                    show-expand
                    dense
                  >
                    <template v-slot:item.totalPrice="{ item }">
                      <v-chip dark small>
                        {{ formatCurrency(0, item.totalPrice) }}
                      </v-chip>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                      <td
                        :colspan="headers.length"
                        dense
                        v-if="item.options && item.options.length > 0"
                      >
                        <v-row
                          dense
                          class="mt-1"
                          v-for="(i, index) in item.options"
                          :key="index"
                        >
                          <v-col cols="1">{{ index + 1 }}</v-col>
                          <v-col cols="2">{{ i.externalCode }}</v-col>
                          <v-col cols="3"> {{ i.name }} </v-col>
                          <v-col cols="2">
                            {{ i.quantity * item.quantity }} {{ i.unit }}</v-col
                          >
                          <v-col cols="2"> </v-col>
                          <v-col>
                            <v-chip dark small>
                              {{ formatCurrency(0, i.price * item.quantity) }}
                            </v-chip></v-col
                          >
                        </v-row>
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red darken-1" @click="$emit('goBack')">Fechar</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </template>
  </base-dialog>
</template>
<script>
import BaseDialog from '@/components/shared/base-dialog/BaseDialog'
import { mapActions, mapGetters } from 'vuex'
import { currencyMixin } from '@/mixins/object/currency/CurrencyMixin'
import cInputMoney from '@/components/shared/base-input/BaseInputMoney.vue'

export default {
  mixins: [currencyMixin],
  components: { BaseDialog, cInputMoney },
  data: () => {
    return {
      selectedTab: 0,
      order: {},
    }
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    orderData: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      currenciesList: 'systemModule/getSystemCurrencies',
    }),
    headersMethods() {
      console.log(this.orderData)
      return [
        { text: 'Card', value: 'card.brand' },
        { text: 'Moeda', value: 'currency' },
        { text: 'Metódo', value: 'method' },
        { text: 'Já pago', value: 'prepaid' },
        { text: 'Origem', value: 'type' },
        { text: 'Valor', value: 'value' },
      ]
    },
    headersItems() {
      return [
        { text: 'Código', value: 'externalCode' },
        { text: 'Descrição', value: 'name' },
        { text: 'Quantidade', value: 'quantity' },
        { text: 'Um', value: 'unit' },
        { text: 'Valor', value: 'totalPrice' },
      ]
    },
  },
  methods: {
    ...mapActions({
      getcurrencyAPI: 'currencyModule/getCurrency',
    }),
    getQntDecimais(currency) {
      return currency.mascara.indexOf('.') != -1 ? 2 : 0
    },
  },
  mounted() {
    if (this.currenciesList.length < 1) this.getcurrencyAPI({ page: 1 })

    console.log(this.currenciesList)
  },
}
</script>

<style></style>
